import UiColorPicker from '../../components/color-picker/ui-color-picker'
import isCalculation from '../../helpers/is-calculation'
import { onAnyStandardCell, renderCalcPos } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const uiColorColumn: CalculationColumn = {
    dataIndex: 'uiColor',
    title: '',
    width: 10,
    render: renderCalcPos((r, v) => {
        return <UiColorPicker value={v} record={r} />
    }),
    onCell: onAnyStandardCell,
}
